import styled from '@emotion/styled';
import { Text } from '@/components/atoms/Text';

export const ImageInputModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100%;
    width: 800px;
    align-items: center;
    justify-content: center;
    margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TabsContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
    margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const ImageIconButtonContainer = styled.div`
    position: absolute;
    right: 12px;
    bottom: 12px;
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const ImageIconButton = styled.button<{ destructive?: boolean }>`
    border: solid 1px ${({ theme }) => theme.color.grey300};
    border-radius: ${({ theme }) => theme.radius.main};
    color: ${({ destructive, theme }) => (destructive ? theme.color.io.destructive500 : 'inherit')};
    font-size: 18px;
    width: 32px;
    height: 32px;

    cursor: pointer;

    transition: background-color 0.2s ease-in-out;

    background-color: ${({ theme }) => theme.color.grey100};
    &:hover {
        background-color: ${({ theme }) => theme.color.grey300};
    }
`;

export const ImageContainer = styled.div`
    width: 200px;
    height: 200px;
    border-radius: ${({ theme }) => theme.radius.main};
    position: relative;

    overflow: hidden;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    > img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
    > span {
        font-size: 100px;
        color: ${({ theme }) => theme.color.grey500};
    }
    box-shadow: ${({ theme }) => theme.shadow.legacy};
`;

export const GRID_ROW_ITEMS = 5;
export const GRID_ROW_HEIGHT = 150;
export const TEXT_HEIGHT = 30;

export const ImageLibraryListContainer = styled.div`
    display: flex;
    flex: 1;
    overflow-y: auto;
    padding: ${({ theme }) => theme.spacing[2]};

    width: 100%;
    position: relative;
`;

export const ImagerLibraryRow = styled.div<{ rowSize: number; rowStart: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    height: ${({ rowSize }) => rowSize}px;
    transform: translateY(${({ rowStart }) => rowStart}px);

    display: grid;
    gap: ${({ theme }) => theme.spacing[2]};
    grid-template-columns: repeat(${GRID_ROW_ITEMS}, minmax(${GRID_ROW_HEIGHT}px, 1fr));
    grid-auto-rows: ${GRID_ROW_HEIGHT}px;
`;

export const ImageLibraryItemContainer = styled.div``;

export const ImageLibraryItem = styled(ImageContainer)`
    width: 100%;
    height: 100%;

    border: 2px solid transparent;
    &[data-selected='true'] {
        border-color: ${({ theme }) => theme.color.primary};
    }
`;

export const ImageLibraryItemText = styled(Text)`
    width: 100%;
    overflow: hidden;
    word-break: break-all;
`;
